import { PollConfig, SINGLE_TYPE } from '../../../../configFields';

export const config: PollConfig & { name: 'POLL_BINARY' } = {
  name: 'POLL_BINARY' as const,
  traits: [SINGLE_TYPE],
  title: 'Бинарный',
};
